export default function GalleryPage({ items }) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-center gap-6">
        {items.slice(0, 3).map((item) => (
          <div
            key={item.id}
            className="
              w-[280px]
              rounded-2xl
              overflow-hidden
              shadow-md
              bg-blue
              text-white
            "
          >
            <div className="text-center bg-gray-100 text-white py-2 font-semibold">
              Zona {item.regiao}
            </div>

            <img
              src={`${process.env.REACT_APP_API_URL}${item.imagem}`}
              className="w-full h-[140px] object-cover object-center"
              alt={item.nome}
            />

            <div className="p-3 text-center font-semibold">{item.nome}</div>
          </div>
        ))}
      </div>

      <div className="flex justify-center gap-6">
        {items.slice(3, 7).map((item) => (
          <div
            key={item.id}
            className="
              w-[280px]
              rounded-2xl
              overflow-hidden
              shadow-md
              bg-blue
              text-white
            "
          >
            <div className="text-center bg-gray-100 text-white py-2 font-semibold">
              Zona {item.regiao}
            </div>

            <img
              src={`${process.env.REACT_APP_API_URL}${item.imagem}`}
              className="w-full h-[140px] object-cover object-center"
              alt={item.nome}
            />

            <div className="p-3 text-center font-semibold">{item.nome}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
